module.exports = __webpack_public_path__ + "img/item_morningglow_ida_2024.980ccb5.webp";